/* https://relinks.myjetbrains.com/youtrack/issue/AB-110/AB-151-menu-op-mobiel

    if (window.ab151) {
        clearInterval(window.ab151);
    }
    window.ab151 = setInterval(function () {
        if (document.querySelector('body')) {
            // Add class to body
            document.querySelector('body').classList.add('ab-151');
            // Clear
            clearInterval(window.ab151);
        }
    });

*/

export const ab151 = (function () {
  const init = function () {
    const el = document.querySelector("#main-header-container");
    let isPinned = false; // Track if the header is pinned

    // Function to check scroll position
    const checkScrollPosition = () => {
      if (window.scrollY > 0 && !isPinned) {
        // Page has been scrolled down, pin the header
        el.classList.add("is-pinned");
        isPinned = true;
        setHeaderHeight();
      } else if (window.scrollY === 0 && isPinned) {
        // Page is at the top, unpin the header
        el.classList.remove("is-pinned");
        isPinned = false;
        setHeaderHeight(false);
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", checkScrollPosition);

    const bodyObserver = new MutationObserver(function (
      mutationsList,
      observer,
    ) {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          setHeaderHeight(!el.classList.contains("is-pinned"));
        }
      }
    });

    bodyObserver.observe(document.body, { attributes: true });
  };

  const setHeaderHeight = (withActionBanner = true) => {
    const el = document.querySelector("#main-header-container");
    const actionBar = document.querySelector(".top-banner.open");
    const ratingBar = document.querySelector(".company-rating-widget-banner");

    let offset =
      el.offsetHeight +
      (ratingBar?.offsetHeight ?? 0) +
      (withActionBanner ? (actionBar?.offsetHeight ?? 0) : 0);

    if (el.classList.contains("is-pinned")) {
      offset =
        el.offsetHeight +
        (withActionBanner ? (actionBar?.offsetHeight ?? 0) : 0);
    }

    document
      .querySelector(":root")
      .style.setProperty("--header-height", `${offset}px`);
  };

  return {
    init: init,
  };
})();
